import { client } from "../client";
export var getMusicArchiveById = function (id) {
    return client
        .get("/api/v2/music-archives/".concat(id))
        .then(function (response) {
        return response.data.data;
    });
};
